import ImpersonateContainer from './ImpersonateContainer'

export { Impersonate } from './Impersonate'
export default ImpersonateContainer
